<i class="icon-component label-icon" :class="iconClass"><slot></slot></i>